import Dashboard from '../components/Dashboard';

function Quant() {
  return <Dashboard mode="quant" />;
}

export default Quant;
